var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.syncUI.drawUrl),expression:"syncUI.drawUrl"}],staticClass:"flex_c draw-url"},[(_vm.syncUI.drawUrl)?_c('iframe',{staticClass:"draw-iframe",attrs:{"src":_vm.syncUI.drawUrl,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }